import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
    CdsAlertModule,
    CdsButtonInlineModule,
    CdsButtonModule,
    CdsCheckboxModule,
    CdsFormsModule,
    CdsIconModule,
    CdsInputModule,
    CdsModalModule,
    CdsPasswordModule,
    CdsProgressCircleModule,
    CdsRadioModule,
    CdsRangeModule,
    CdsSelectModule,
    CdsAccordionModule,
    CdsTreeViewModule,
} from '@cds/angular'
import {
    ClarityIcons,
    eyeHideIcon,
    eyeIcon,
    windowCloseIcon,
    fileIcon,
    folderIcon,
    folderOpenIcon,
    plusIcon,
    minusIcon,
    searchIcon,
    arrowIcon,
    angleIcon,
    trashIcon,
    refreshIcon,
    pencilIcon,
    axisChartIcon,
    copyToClipboardIcon,
    successStandardIcon,
    infoStandardIcon,
    warningStandardIcon,
    errorStandardIcon,
    downloadIcon,
    cogIcon,
} from '@cds/core/icon'
import { ClrComboboxModule, ClrIconModule, ClrFormsModule } from '@clr/angular'
import { NgxColorsModule } from 'ngx-colors'
import { CdkTreeModule } from '@angular/cdk/tree'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { DialogModule } from '@angular/cdk/dialog'
import { ClipboardModule } from '@angular/cdk/clipboard'
import { ToastrModule } from 'ngx-toastr'
import { OverlayModule } from '@angular/cdk/overlay'
import { PortalModule } from '@angular/cdk/portal'

const CDS_MODULES = [
    CdsAlertModule,
    CdsButtonInlineModule,
    CdsButtonModule,
    CdsFormsModule,
    CdsIconModule,
    CdsInputModule,
    CdsModalModule,
    CdsPasswordModule,
    CdsRadioModule,
    CdsRangeModule,
    CdsSelectModule,
    CdsProgressCircleModule,
    CdsCheckboxModule,
    CdsAccordionModule,
    CdsTreeViewModule,
    ClrComboboxModule,
    ClrIconModule,
    ClrFormsModule,
]

ClarityIcons.addIcons(eyeIcon)
ClarityIcons.addIcons(eyeHideIcon)
ClarityIcons.addIcons(windowCloseIcon)
ClarityIcons.addIcons(fileIcon)
ClarityIcons.addIcons(folderIcon)
ClarityIcons.addIcons(folderOpenIcon)
ClarityIcons.addIcons(plusIcon)
ClarityIcons.addIcons(minusIcon)
ClarityIcons.addIcons(arrowIcon)
ClarityIcons.addIcons(angleIcon)
ClarityIcons.addIcons(trashIcon)
ClarityIcons.addIcons(refreshIcon)
ClarityIcons.addIcons(pencilIcon)
ClarityIcons.addIcons(axisChartIcon)
ClarityIcons.addIcons(copyToClipboardIcon)
ClarityIcons.addIcons(successStandardIcon)
ClarityIcons.addIcons(infoStandardIcon)
ClarityIcons.addIcons(warningStandardIcon)
ClarityIcons.addIcons(errorStandardIcon)
ClarityIcons.addIcons(downloadIcon)
ClarityIcons.addIcons(cogIcon)
ClarityIcons.addIcons(searchIcon)
const ANGULAR_CDK_MODULES = [
    CdkTreeModule,
    DragDropModule,
    DialogModule,
    ClipboardModule,
    OverlayModule,
    PortalModule,
]

const MISC_MODULES = [NgxColorsModule]

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ...CDS_MODULES,
        ...ANGULAR_CDK_MODULES,
        ...MISC_MODULES,
        ToastrModule.forRoot(),
    ],
    exports: [...CDS_MODULES, ...ANGULAR_CDK_MODULES, ...MISC_MODULES, ToastrModule],
})
export class UiLibraryModule {}
